import React, { Suspense, lazy, useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './App.css';

const ProtectedRoute = lazy(() => import("./Routing/ProtectedRoute"));
const PublicRoute = lazy(() => import("./Routing/PublicRoute"));
const TabTitle = lazy(() => import("./Routing/TabTitle"));

// Public pages
const Login = lazy(() => import("./Users/Login"));
const Signup = lazy(() => import("./Users/Signup"));
const ForgetPassword = lazy(() => import("./Users/ForgetPassword"));
const ResetPassword = lazy(() => import("./Users/ResetPassword"));
const CreatePassword = lazy(() => import("./Users/CreatePassword"));

function App() {
  // const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem("authtoken"));

  // useEffect(() => {
  //   const checkAuth = () => {
  //     const token = localStorage.getItem("authtoken");
  //     setIsAuthenticated(!!token);
  //   };

  //   window.addEventListener("storage", checkAuth);
  //   return () => window.removeEventListener("storage", checkAuth);
  // }, []);

  return (
    <div className="App">
      <Router>
        <Suspense  >
          <TabTitle />
          <Routes>
            {/* ✅ Public routes grouped under PublicRoute */}
            <Route element={<PublicRoute />}>
              <Route path="/" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/forgetpassword" element={<ForgetPassword />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
              <Route path="/create-password/:token" element={<CreatePassword />} />
            </Route>

            {/* ✅ Protected routes */}
            <Route path="/*" element={<ProtectedRoute />} />
          </Routes>
        </Suspense>
      </Router>
    </div>
  );
}

export default App;
